import React, { useEffect, useState } from "react";
import { useParams, useNavigate } from "react-router-dom";
import { getDoc, doc } from "firebase/firestore";
import {
  db,
  getDocDataSnap,
  setDocData,
} from "../../utils/firebase/Firebase.utils";
import {
  FaArrowLeft,
  FaClock,
  FaUser,
  FaHome,
  FaClipboardList,
  FaComment,
  FaImage,
  FaVideo,
} from "react-icons/fa";
import BackButton from "../../components/BackButton";
import TaskAssignmentModule from "../../components/TaskAssignmentModule";
import CommentsSection from "../../components/CommentsSection";
import HistoryModule from "../../components/HistoryModule";
import { useSelector } from "react-redux";
import { MdEdit } from "react-icons/md";
import ConcernsPageDetails from "../Dashboard/Concerns/ConcernsPageDetails";
import UserScreenWindow from "../User/Components/UserScreenWindow";

export default function AdminMobileConcernDetails() {
  const { id } = useParams();
  const [concern, setConcern] = useState(null);
  const [loading, setLoading] = useState(true);
  const [assignedTo, setAssignedTo] = useState([]);
  const [editMode, setEditMode] = useState(false);
  const [concernComments, setConcernComments] = useState([]);
  const currentUser = useSelector((state) => state.userObject);

  useEffect(() => {
    const fetchConcern = async () => {
      await getDocDataSnap("concerns", id, (data) => {
        setConcern(data);
        setConcernComments(data.comments || []);
        setLoading(false);
      });
    };

    fetchConcern();
  }, [id]);

  if (loading) {
    return (
      <div className="flex items-center justify-center min-h-screen">
        <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-eleghoBlue"></div>
      </div>
    );
  }

  if (!concern) {
    return (
      <div className="p-4">
        <BackButton />
        <div className="mt-8 text-center">
          <p className="text-gray-500">Concern not found</p>
        </div>
      </div>
    );
  }
  return (
    <UserScreenWindow label="Concern Details">
      <div>
        <ConcernsPageDetails concern={concern} />
      </div>
    </UserScreenWindow>
  );
}
